import { createComponentStore } from "@tecnobit-srl/components-store";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
var { Component: InnerRoute, ComponentStoreProvider: RouteTypesProvider, useAddComponent: useAddRouteType } = createComponentStore("route-types");
function Route(props) {
	return /* @__PURE__ */ jsx(InnerRoute, {
		id: props.type,
		p: { route: props }
	});
}
//#endregion
export { Route, RouteTypesProvider, useAddRouteType };
